import withResponsive from '../hoc/withResponsive'
import Swiper from 'swiper/dist/js/swiper.min.js'
import onResize from '../utils/onResize'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'slider',

  ui: {
    pagination: '[js-slider-pagination]',
    navigation: '[js-slider-navigation]',
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))
    if (this.ui.pagination) {
      this.props.options.pagination = {
        el: this.ui.pagination,
        type: 'bullets',
        clickable: true,
      }
    }

    if (this.ui.navigation) {
      this.props.options.navigation = {
        nextEl: this.ui.navigation.querySelector('.swiper-button-next'),
        prevEl: this.ui.navigation.querySelector('.swiper-button-prev'),
      }
    }
    this.props.options.threshold = 10
    this.slider = new Swiper(this.el, this.props.options)
    if (this.slider && this.slider.slides !== undefined) {
      this.checkDisable()
    }
  },

  componentWillUnmount () {
    this.off()

    this.slider.destroy()
    if (this.ui.pagination) this.ui.pagination.innerHTML = ''
  },

  onResize () {
    if (this.slider && this.slider.slides !== undefined) {
      setTimeout(() => {
        this.checkDisable()
      }, 500)
    }
  },

  checkDisable () {
    if (this.slider.slides !== 'undefined') {
      const nbSlides = this.slider.slides.length

      if (window.innerWidth < 768 && nbSlides < 2) {
        // this.slider.allowTouchMove = false
        if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
      } else {
        // this.slider.allowTouchMove = true
        if (this.ui.pagination) this.ui.pagination.classList.remove('is-hidden')
      }

      if (!this.props.options.breakpoints) return
      Object.entries(this.props.options.breakpoints).forEach(breakpoint => {
        if (
          window.innerWidth >= breakpoint[0] &&
          nbSlides / breakpoint[1].slidesPerView <= 1
        ) {
          // this.slider.allowTouchMove = false
          if (this.ui.pagination) this.ui.pagination.classList.add('is-hidden')
        } else {
          // this.slider.allowTouchMove = true
          if (this.ui.pagination) {
            this.ui.pagination.classList.remove('is-hidden')
          }
        }
      })
    }
  },
})
